export const locales = [
  { code: 'en', flag: 'flags/_en.png', name: 'English' },
  { code: 'es', flag: 'flags/_es.png', name: 'Español' },
  { code: 'fr', flag: 'flags/_fr.png', name: 'Français' },
  { code: 'zh', flag: 'flags/_zh.png', name: '中文' },
];
